// 数据更新公告正文的轻量排版约定（仍是纯文本，后台字段与接口不变）：
//   「## 」开头 = 小标题；「- 」开头 = 列表项（相邻的合成一组）；「> 」开头 = 末尾提示（斜体）；
//   行内 **文字** = 加粗；其余每行一段。旧公告没有这些标记，按段落原样显示。
// 只产出结构化数据由模板渲染，不拼 HTML，正文里的尖括号等按文本显示。

/** 正文 → 块列表：{ type: 'heading' | 'list' | 'note' | 'paragraph', text?, items? } */
export function parseAnnouncementContent(content) {
  const blocks = []
  for (const raw of String(content || '').split(/\n+/)) {
    const line = raw.trim()
    if (!line) continue
    if (line.startsWith('## ')) blocks.push({ type: 'heading', text: line.slice(3).trim() })
    else if (/^[-•]\s+/.test(line)) {
      const item = line.replace(/^[-•]\s+/, '')
      const last = blocks[blocks.length - 1]
      if (last?.type === 'list') last.items.push(item)
      else blocks.push({ type: 'list', items: [item] })
    } else if (line.startsWith('> ')) blocks.push({ type: 'note', text: line.slice(2).trim() })
    else blocks.push({ type: 'paragraph', text: line })
  }
  return blocks
}

/** 是否用了排版约定：用了就是面向用户的公告，不再追加「本次更新重点」清单。 */
export const isStructuredAnnouncement = content => parseAnnouncementContent(content).some(block => block.type !== 'paragraph')

/** 紧凑列表只显示正文文字；摘要在服务端截断时也不露出未闭合的加粗标记。 */
export const announcementPlainText = content => parseAnnouncementContent(content)
  .flatMap(block => block.items || [block.text]).map(text => text.replace(/\*\*/g, '')).join(' ')

/** 行内加粗：'新增 **272 个** 数据集' → [{ text, bold }] */
export function splitBold(text) {
  const parts = []
  const pattern = /\*\*(.+?)\*\*/g
  let index = 0
  let match
  while ((match = pattern.exec(text))) {
    if (match.index > index) parts.push({ text: text.slice(index, match.index), bold: false })
    parts.push({ text: match[1], bold: true })
    index = match.index + match[0].length
  }
  if (index < text.length) parts.push({ text: text.slice(index), bold: false })
  return parts
}
